(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9035],{

/***/ 7746:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ Tabs; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8777);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);



function Tabs(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledTabs, {
    className: props.className,
    children: props.tabs.map(function (item) {
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledTab, {
        onClick: function onClick() {
          return props.setActiveTab(item.id);
        },
        isActive: item.id === props.activeTab,
        children: item.title
      }, item.id);
    })
  });
}
var StyledTabs = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "Tabs__StyledTabs",
  componentId: "sc-7ebgwn-0"
})(["display:grid;grid-auto-flow:column;justify-content:flex-start;grid-gap:1.2rem;"]);
var StyledTab = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].button.withConfig */ .ZP.button.withConfig({
  displayName: "Tabs__StyledTab",
  componentId: "sc-7ebgwn-1"
})(["padding:0.8rem 1.2rem;border-radius:0.4rem;font-size:1.6rem;color:", ";border:1px solid ", ";background-color:", ";transition:all 0.3s ease;&:hover{color:", ";border-color:", ";}@media screen and (max-width:", "){padding:1.2rem;}"], function (_ref) {
  var isActive = _ref.isActive,
      theme = _ref.theme;
  return isActive ? theme.colors.basic_white : theme.colors.primary_light_gray;
}, function (_ref2) {
  var isActive = _ref2.isActive,
      theme = _ref2.theme;
  return isActive ? theme.colors.primary_red : theme.colors.primary_light_gray;
}, function (_ref3) {
  var isActive = _ref3.isActive,
      theme = _ref3.theme;
  return isActive ? theme.colors.primary_red : "none";
}, function (_ref4) {
  var isActive = _ref4.isActive,
      theme = _ref4.theme;
  return isActive ? theme.colors.basic_white : theme.colors.primary_red;
}, function (props) {
  return props.theme.colors.primary_red;
}, function (props) {
  return props.theme.sizes.tabletMin;
});

/***/ }),

/***/ 6920:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ Index; }
});

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./features/Layout/index.tsx + 16 modules
var Layout = __webpack_require__(4999);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(8777);
// EXTERNAL MODULE: ./shared/ui/sharedstyles.tsx
var sharedstyles = __webpack_require__(8512);
// EXTERNAL MODULE: ./shared/ui/Tabs/index.tsx
var Tabs = __webpack_require__(7746);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./shared/ui/Typography/index.tsx
var Typography = __webpack_require__(4006);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./entities/Contacts/ContactInfo/index.tsx






var Icon = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 2185).then(__webpack_require__.bind(__webpack_require__, 2185));
}, {
  suspense: true,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(2185)];
    }
  }
});
function ContactInfo(_ref) {
  var title = _ref.title,
      children = _ref.children,
      iconName = _ref.iconName;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledView, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(react.Suspense, {
      fallback: "icon",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Icon, {
        name: iconName,
        iconColor: "primary_red",
        iconSize: 32
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StyledTitle, {
        tag: "h4",
        fontSize: "1.8rem",
        weight: 500,
        children: title
      }), children]
    })]
  });
}
var StyledView = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ContactInfo__StyledView",
  componentId: "sc-1mm52k9-0"
})(["display:grid;grid-gap:1.6rem;grid-auto-flow:column;align-items:flex-start;justify-content:flex-start;"]);
var StyledTitle = (0,styled_components_browser_esm/* default */.ZP)(Typography/* Typography */.Z).withConfig({
  displayName: "ContactInfo__StyledTitle",
  componentId: "sc-1mm52k9-1"
})(["margin-bottom:0.8rem;"]);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 14 modules
var esm = __webpack_require__(6720);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(1163);
;// CONCATENATED MODULE: ./src/pages/main/contacts/index.tsx














var YandexMap = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 458).then(__webpack_require__.bind(__webpack_require__, 458));
}, {
  ssr: true,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(458)];
    }
  }
});
var __N_SSP = true;
function Index(props) {
  var _currentCity$addresse;

  var _useTranslation = (0,esm/* useTranslation */.$G)(),
      t = _useTranslation.t;

  var _useRouter = (0,router.useRouter)(),
      locale = _useRouter.locale,
      push = _useRouter.push,
      pathname = _useRouter.pathname,
      query = _useRouter.query;

  var _useState = (0,react.useState)(function () {
    var _props$contacts$citie, _props$contacts$citie2;

    var hasQueryCity = props.contacts.cities.some(function (city) {
      return city.id === Number(query === null || query === void 0 ? void 0 : query.cityId);
    });
    return hasQueryCity ? Number(query === null || query === void 0 ? void 0 : query.cityId) : (_props$contacts$citie = props.contacts.cities) === null || _props$contacts$citie === void 0 ? void 0 : (_props$contacts$citie2 = _props$contacts$citie[0]) === null || _props$contacts$citie2 === void 0 ? void 0 : _props$contacts$citie2.id;
  }),
      activeCityId = _useState[0],
      setActiveCityId = _useState[1];

  var _useState2 = (0,react.useState)(null),
      currentAddressId = _useState2[0],
      setCurrentAddressId = _useState2[1];

  var currentCity = (0,react.useMemo)(function () {
    var _city$addresses$0$id, _city$addresses, _city$addresses$;

    var city = props.contacts.cities.find(function (item) {
      return item.id === activeCityId;
    });
    setCurrentAddressId((_city$addresses$0$id = city === null || city === void 0 ? void 0 : (_city$addresses = city.addresses) === null || _city$addresses === void 0 ? void 0 : (_city$addresses$ = _city$addresses[0]) === null || _city$addresses$ === void 0 ? void 0 : _city$addresses$.id) !== null && _city$addresses$0$id !== void 0 ? _city$addresses$0$id : 0);
    return city;
  }, [activeCityId, locale]);
  var coordinates = (0,react.useMemo)(function () {
    return props.contacts.cities.map(function (value) {
      return value.addresses;
    }).flat(1);
  }, [locale]);
  var currentCenter = (0,react.useMemo)(function () {
    var _coordinates$find;

    return (_coordinates$find = coordinates.find(function (item) {
      return item.id === currentAddressId;
    })) !== null && _coordinates$find !== void 0 ? _coordinates$find : currentCity === null || currentCity === void 0 ? void 0 : currentCity.addresses[0];
  }, [currentAddressId, locale]);

  var setCity = function setCity(id) {
    push({
      href: pathname,
      query: {
        cityId: id
      }
    }, {
      href: pathname,
      query: {
        cityId: id
      }
    }, {
      shallow: true
    });
    setActiveCityId(id);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)((head_default()), {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("title", {
        children: t("\u0411\u041D\u041A \u0424\u0438\u043D\u0430\u043D\u0441 \u041A\u0430\u0437\u0430\u0445\u0441\u0442\u0430\u043D")
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledContent, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StyledTabs, {
        tabs: props.contacts.cities.map(function (value) {
          return {
            id: value.id,
            title: value.name
          };
        }),
        activeTab: activeCityId,
        setActiveTab: setCity
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledContact, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StyledMapWrapper, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(YandexMap, {
            center: [Number(currentCenter.latitude), Number(currentCenter.longitude)],
            placemarks: coordinates.map(function (item) {
              return [Number(item.latitude), Number(item.longitude)];
            })
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledContactInfoWrapper, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ContactInfo, {
            title: t("\u0410\u0434\u0440\u0435\u0441 \u043E\u0444\u0438\u0441\u0430"),
            iconName: "Location",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(StyledAddressesWrapper, {
              children: currentCity === null || currentCity === void 0 ? void 0 : currentCity.addresses.map(function (address) {
                return /*#__PURE__*/(0,jsx_runtime.jsx)(StyledAddress, {
                  onClick: function onClick() {
                    return setCurrentAddressId(address.id);
                  },
                  tag: "p",
                  weight: 400,
                  children: address.name
                }, address.id);
              })
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(ContactInfo, {
            title: t("\u0427\u0430\u0441\u044B \u0440\u0430\u0431\u043E\u0442\u044B"),
            iconName: "Time",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
              tag: "p",
              weight: 400,
              children: (_currentCity$addresse = currentCity.addresses) === null || _currentCity$addresse === void 0 ? void 0 : _currentCity$addresse[0].working_time
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledCallCenterWrapper, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              href: "tel:".concat(props.contacts.phone),
              style: {
                whiteSpace: "nowrap",
                display: "block"
              },
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledCallCenterText, {
                children: [t("\u0415\u0434\u0438\u043D\u044B\u0439 call-\u0446\u0435\u043D\u0442\u0440"), " ", /*#__PURE__*/(0,jsx_runtime.jsx)("b", {
                  children: props.contacts.phone
                })]
              })
            })
          })]
        })]
      })]
    })]
  });
}

Index.getLayout = function getLayout(page) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Layout/* Layout */.A, {
    children: page
  });
};

var StyledContent = (0,styled_components_browser_esm/* default */.ZP)(sharedstyles/* Container */.W).withConfig({
  displayName: "contacts__StyledContent",
  componentId: "sc-1jyytc5-0"
})(["padding-top:8rem;padding-bottom:8rem;@media screen and (max-width:", "){padding-top:4.8rem;padding-bottom:6.4rem;}"], function (props) {
  return props.theme.sizes.tabletMin;
});
var StyledTabs = (0,styled_components_browser_esm/* default */.ZP)(Tabs/* Tabs */.m).withConfig({
  displayName: "contacts__StyledTabs",
  componentId: "sc-1jyytc5-1"
})(["margin-bottom:4.8rem;@media screen and (max-width:", "){margin-bottom:4rem;}"], function (props) {
  return props.theme.sizes.tabletMin;
});
var StyledMapWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "contacts__StyledMapWrapper",
  componentId: "sc-1jyytc5-2"
})(["border-radius:0.4rem;overflow:hidden;height:32.5rem;@media screen and (max-width:", "){order:2;height:47.4rem;}"], function (props) {
  return props.theme.sizes.tabletMin;
});
var StyledContact = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "contacts__StyledContact",
  componentId: "sc-1jyytc5-3"
})(["margin-bottom:4.8rem;display:grid;grid-template-columns:1fr 0.5fr;grid-gap:3.2rem;@media screen and (max-width:", "){grid-template-columns:1fr;}"], function (props) {
  return props.theme.sizes.tabletMin;
});
var StyledContactInfoWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "contacts__StyledContactInfoWrapper",
  componentId: "sc-1jyytc5-4"
})(["display:grid;grid-gap:4rem;align-content:flex-start;@media screen and (max-width:", "){grid-gap:3.2rem;order:1;}"], function (props) {
  return props.theme.sizes.tabletMin;
});
var StyledCallCenterWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "contacts__StyledCallCenterWrapper",
  componentId: "sc-1jyytc5-5"
})(["border-radius:0.8rem;padding:2.4rem;background-color:", "1a;"], function (props) {
  return props.theme.colors.primary_light_gray;
});
var StyledAddressesWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "contacts__StyledAddressesWrapper",
  componentId: "sc-1jyytc5-6"
})(["display:grid;grid-gap:0.4rem;"]);
var StyledAddress = (0,styled_components_browser_esm/* default */.ZP)(Typography/* Typography */.Z).withConfig({
  displayName: "contacts__StyledAddress",
  componentId: "sc-1jyytc5-7"
})(["&:hover{cursor:pointer;}"]);
var StyledCallCenterText = (0,styled_components_browser_esm/* default */.ZP)(Typography/* Typography */.Z).withConfig({
  displayName: "contacts__StyledCallCenterText",
  componentId: "sc-1jyytc5-8"
})(["white-space:break-spaces;"]);

/***/ }),

/***/ 9583:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/main/contacts",
      function () {
        return __webpack_require__(6920);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [8359,1664,5675,2151,7802,301,4999,9774,2888,179], function() { return __webpack_exec__(9583); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);